import React from 'react';
import { FadeUp } from '../components/AnimatedSection';
import { useLanguage } from '../context/LanguageContext';

const ShippingPage = () => {
  const { language, t } = useLanguage();

  const contentEn = (
    <div className="space-y-8 max-w-3xl">
      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Shipping to Spain</h2>
        <p className="text-[#86868B] leading-relaxed">
          Delivery time: 7-13 business days.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">International Shipping</h2>
        <p className="text-[#86868B] leading-relaxed">
          We ship worldwide. Delivery times vary by destination. International orders may be subject 
          to customs duties and import taxes, which are the responsibility of the recipient.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Order Processing</h2>
        <p className="text-[#86868B] leading-relaxed">
          Orders are processed within 1-2 business days. You will receive a confirmation email 
          with tracking information once your order ships.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Contact</h2>
        <p className="text-[#86868B] leading-relaxed">
          For shipping questions, contact us at contact.tivorao@gmail.com
        </p>
      </section>
    </div>
  );

  const contentEs = (
    <div className="space-y-8 max-w-3xl">
      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Envío a España</h2>
        <p className="text-[#86868B] leading-relaxed">
          Tiempo de entrega: 7-13 días hábiles.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Envío Internacional</h2>
        <p className="text-[#86868B] leading-relaxed">
          Enviamos a todo el mundo. Los tiempos de entrega varían según el destino. Los pedidos 
          internacionales pueden estar sujetos a aranceles aduaneros e impuestos de importación, 
          que son responsabilidad del destinatario.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Procesamiento de Pedidos</h2>
        <p className="text-[#86868B] leading-relaxed">
          Los pedidos se procesan en 1-2 días hábiles. Recibirás un correo electrónico de confirmación 
          con la información de seguimiento una vez que se envíe tu pedido.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Contacto</h2>
        <p className="text-[#86868B] leading-relaxed">
          Para preguntas sobre envíos, contáctenos en contact.tivorao@gmail.com
        </p>
      </section>
    </div>
  );

  return (
    <div data-testid="shipping-page" className="min-h-screen bg-black">
      <div className="container-apple section-content pt-32">
        <FadeUp>
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight mb-4">
            {t('legal.shippingTitle')}
          </h1>
          <p className="text-[#86868B] mb-12">{t('legal.lastUpdated')}: December 2025</p>
          {language === 'es' ? contentEs : contentEn}
        </FadeUp>
      </div>
    </div>
  );
};

export default ShippingPage;
